import * as React from "react";

import { useFormikContext } from "formik";

import {
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import type { FormikInitialValuesNewRequest } from "../../../model/form.model";

import { CollapsibleSectionCard } from "../../components/CollapsibleSectionCard";

function getPreview(text: string, maxChars: number) {
  const t = (text ?? "").trim();
  if (!t) return "";
  return t.length <= maxChars ? t : `${t.slice(0, maxChars).trim()}…`;
}

export function ObservationStepDesktop() {
  const { values, setFieldValue, handleBlur } = useFormikContext<
    FormikInitialValuesNewRequest
  >();

  const preview = getPreview(values.observation.observationNote, 90);

  return (
    <CollapsibleSectionCard
      title="Adicionar observação"
      defaultExpanded
      preview={preview}
    >
      <Stack spacing={2}>
        <TextField
          label="Observação"
          name="observation.observationNote"
          value={values.observation.observationNote}
          onChange={(e) =>
            setFieldValue("observation.observationNote", e.target.value)
          }
          onBlur={handleBlur}
          multiline
          minRows={5}
          maxRows={8}
          placeholder="Digite uma observação (opcional)"
          fullWidth
        />

        <FormControlLabel
          control={
            <Checkbox
              name="observation.commentsInInvoice"
              checked={values.observation.commentsInInvoice}
              onChange={(e) =>
                setFieldValue("observation.commentsInInvoice", e.target.checked)
              }
              onBlur={handleBlur}
            />
          }
          label={
            <Stack spacing={0.25}>
              <Typography>Incluir observação na nota fiscal</Typography>
              <Typography variant="caption" color="text.secondary">
                A observação será impressa na NF-e
              </Typography>
            </Stack>
          }
        />
      </Stack>
    </CollapsibleSectionCard>
  );
}
